interface PdfToImagesRequestBody {
  file_blob?: string;
  file_url?: string;
}

interface PdfToImagesResponse {
  success: boolean;
  urls: string[];
  message: string;
}

interface GeneratePresignedUploadUrlRequestBody {
  filename: string;
}

interface GeneratePresignedUploadUrlResponse {
  success: boolean;
  signedUrl: string;
  expiresAt: string;
  publicUrl: string;
}

export class FilesAPI {
  async pdfToImages(_body: PdfToImagesRequestBody): Promise<PdfToImagesResponse> {
    return {
      success: false,
      urls: [],
      message: 'PDF to images conversion is not available in local mode',
    };
  }

  async generatePresignedUploadUrl(
    _body: GeneratePresignedUploadUrlRequestBody,
  ): Promise<GeneratePresignedUploadUrlResponse> {
    const mockUrl = 'blob:local';
    return {
      success: true,
      signedUrl: mockUrl,
      expiresAt: new Date(Date.now() + 3600000).toISOString(),
      publicUrl: mockUrl,
    };
  }
}
